// console.log("in js heavy js");
import { startProject } from "../src/jsHeavy";
startProject();
